// ** Initial state
const initialState = {
  data: [],
  count: 0
}

const fuqarolarReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SEARCH_FUQAROLAR":
      return { ...state, data: action.data.data, count: action.data.count }
    default:
      return state
  }
}

export default fuqarolarReducer
